import './header.scss';

import { CloseOutlined, LogoutOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { closeWebView } from '@/shared/webview/base-actions';
import { useAppSelector } from '@/store';

import { HeaderUserMenu } from '../../ui';
import useHeaderUserMenu from './hooks/useHeaderUserMenu';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const { headerConfig, isInWebView } = useAppSelector((state) => state.app);
  const { userName, profileInitial, handleLogout } = useHeaderUserMenu();

  const userMenuItems: MenuProps['items'] = useMemo(
    () => [
      {
        key: 'profile',
        label: userName || t('layout.userMenu.profile'),
        disabled: true
      },
      {
        type: 'divider'
      },
      {
        key: 'logout',
        label: t('layout.userMenu.logout'),
        icon: <LogoutOutlined />,
        onClick: handleLogout
      }
    ],
    [handleLogout, userName, t]
  );

  return (
    <header className="header">
      {isInWebView ? (
        <div className="header__wrapper">
          <div className="header__title-wrapper">
            <h1 className="header__title">{t('common.title')}</h1>
          </div>
          <button
            onClick={() => closeWebView()}
            className="header__close-button"
          >
            <CloseOutlined />
          </button>
        </div>
      ) : (
        <>
          <div className="header__title-wrapper">
            <h1 className="header__title">{headerConfig.title}</h1>
            {headerConfig.subtitle ? (
              <p className="header__subtitle">{headerConfig.subtitle}</p>
            ) : null}
          </div>
          <div className="header__actions">
            {/* TODO: Уведомления пока не реализованы */}
            {/* <HeaderNotifications /> */}
            <div className="header__user-menu">
              <HeaderUserMenu
                userName={userName}
                profileInitial={profileInitial}
                menuItems={userMenuItems}
              />
            </div>
          </div>
        </>
      )}
    </header>
  );
};

export default Header;
